module.exports = {

    save:      'Enregistrer',
    saved:     'Enregistré',
    close:     'Fermer',
    prev:      'Précédent',
    next:      'Suivant',
    cancel:    'Annuler',
    back:      'Revenir en arrière',
    thanks:    'Merci!',
    send:      'Envoyer',
    show_less: 'Afficher moins',
    show_more: 'Afficher plus',
    perfect:   'Perfect!',
    awesome:   'Great!',
    hello_im:  "Hello, I'm {0}",
    hello:     'Hello',

    labels : {
        user_name:       'Votre nom',
        user_email:      'Votre adresse électronique',
        user_phone:      'Votre numéro de téléphone',
        comments:        'Commentaires supplémentaires',
        date:            'Sélectionnez une date',
        budget_from:     'De',
        budget_to:       'à',
        amount:          'Total',
        currency:        'Devise',
        selection:       'Votre sélection',
        choice_one:      'Choisissez un',
        choice_city:     'Choisissez une ville',
        choice_event:    'Choisissez un événement',
        days_count:      '{count} jour | {count} jours',
        days_more:       'plus de {count} jour | plus de {count} jours',
        day_x:           'Jour {0}',
        total:           'Total',
        hostesses_count: '{count} hôtesse | {count} hôtesses',
        hostesses_more:  'plus de {count} hôtesse | más de {count} hôtesses',
        guests:          '{count} invité | {count} invités',
        services:        '{count} service | {count} services',
        period:          '{count} período | {count} períodos',
        meals:           '{count} comida | {count} comidas',
        city:            'City',
        web:             'Web Page',
    },

    terms_label:       'J’ai lu et j’accepte {0}',
    terms_link_label:  'Politique de confidentialité',

    errors : {

        area      : 'Quelle est la surface du stand?',
        user_name : 'Le champ « nom » est obligatoire',
        user_email: 'Il vous faut une adresse électronique valide',
        user_phone: 'Le champ « numéro de téléphone » est obligatoire',
        estimate:   'An estimate is requierd',
    },

    rq : {

        stands : {


            labels : {
                city: 'Ville où vous avez besoin du stand',
                event: 'Lors de quel salon exposez-vous?',
                size: 'Dimensions du stand',
                price_rank:       'Fourchette de prix',
                price_rank_help : 'Pour sélectionner les bons matériaux lors de la conception de votre stand, veuillez nous indiquer votre fourchette de prix.',
            },

            thanks : {
                title : 'Merci!',
                text  : 'Nous vous enverrons dans les 48 heures qui suivent une sélection des meilleures propositions',
            },

            options_has_design : {

                0 : 'Conception + construction',
                1 : 'Construction uniquement',
                2 : 'Autres services'
            },

            page_start_title:     'Demande de Stand',
            page_start_subtitle : 'Caractéristiques',
            page_start_options_has_design :{

                0: 'J’ai besoin de la conception, de la construction et du montage du stand',
                1: 'J’ai déjà la conception du stand, je n’ai besoin que de sa construction et de son montage',
                2: 'Autres',
            },

            page_user_title:      'Vos coordonnées',
            page_user_subtitle:   '',

            page_price_title:     'Fourchette de prix',
            page_price_subtitle : '',

            page_space_title:    'Avez-vous confirmé votre l’espace dans le salon?',
            page_space_subtitle: '',
            page_space_options : {

                0: 'Non, je ne sais toujours pas si je souhaite exposer et si les coûts d’un stand me conviennent',
                1: 'Oui, j’ai confirmé l’espace et l’emplacement',
            },

            page_type_title    : 'Indiquez-nous le type de stand que vous cherchez',
            page_type_subtitle : '',
            page_type_options : {
                design:  'Stand de conception',
                modular: 'Stand Modulable',
                mixed :  'Stand Mixte',
                display: 'Stand Display',
                none:     'Je ne sais pas encore'
            },

            page_properties_title:     'De quels éléments ou espaces avez-vous besoin dans votre stand?',
            page_properties_subtitle : 'Vous pouvez sélectionner autant d’options que nécessaires',
            page_properties_options: {
                counter:            'Guichet',
                furniture:          'Mobilier',
                multimedia:         'Location multimédia',
                closedMeetingRoom:  'Salle de réunions fermée',
                openMeetingRoom:    'Espace de stockage',
                spaceStorage:       'Salle de réunions ouverte',
                cateringArea:       'Traiteur',
                hangingElements:     'Éléments suspendus',
            },

            page_staff_title:               'How many employees will be in the stand during the event?',
            page_staff_subtitle:            'Specify the number of employees, what position they have, that are going to be in the stand. This information is helpfull for designing the stand. Example: manager + 3 sales person + hostesses',

            page_price_relevance_title :    'How relevant is the price in your purchase decision?',
            page_price_relevance_subtitle : 'Price and design are two sides of the same coin, with a bigger budget more investment in the design and the materials to build the stand. Tell us how important is each of this aspects',
            page_price_relevance_options  : {

                label1 : 'Relevance:',
                label2 : 'Minimum',
                label3 : 'Low',
                label4 : 'Medium',
                label5 : 'High',
                label6 : 'Maximum',
                label7 : 'Price',
                label8 : 'Design',
            },

            page_price_max_title:    'Budget and currency',
            page_price_max_subtitle: 'You selected the price as the most important aspect. What is the maximun budget?',

            page_upload_alt_title:    'Do you want to attach some design, idea or concept of how your stand should be? This would help us to understand better what do you have in mind.',
            page_upload_alt_subtitle: '',

        },

        hostesses : {


            thanks : {
                title : 'Merci!',
                text  : 'Envoyez-nous votre CV à CV.hostesses@neventum.com et nous vous mettrons en lien avec nos agences d’hôtesses partenaires',
            },

            create : {

                1 : {
                    title:       'Demande d’hôtesses',
                    subtitle:    'Dans quelle ville et pour quel événement avez-vous besoin du service?',
                    label1:      'Dans quelle ville avez-vous besoin d’hôtesses?',
                    label2:      'Indiquez le nom de l´événement',
                    placeholder: 'Écrivez ou sélectionnez un élément',
                },
                2: {
                    title  : "Pourriez-vous nous confirmer ces informations, s'il vous plaît?",
                    label1 : 'Confirmer ville',
                    label2 : 'Confirmer date de début',
                },
                3 : {
                    'title'         : 'Demande d’hôtesses',
                    'subtitle'      : 'Vos coordonnées',
                },
                4 : {
                    'title'         : 'Pour obtenir un meilleur service, veuillez indiquer votre profil.',
                    'label1'        : 'Je suis un <b>client</b> qui demande un service d’hôtesses',
                    'label2'        : 'Je suis une <b>agence</b> qui demander des hôtesses pour un client',
                    'label3'        : 'Je suis une <b>hôtesse</b> qui cherche du travail et souhaite transmettre son CV',
                },
                5 : {
                    'title'         : 'Indiquez le nombre d’hôtesses dont vous avez besoin et pendant combien de temps.',
                    'label1'        : 'Hôtesses requises',
                    'label2'        : 'Nombre de jours',
                    'label3'        : 'Malheureusement, nous n’avons pas trouvé l’événement dans notre base de données, veuillez nous indiquer la date à laquelle il commence',
                },
                6 : {
                    'title'         : 'Pendant combien d’heures avez-vous besoin du service d’hôtesses chaque jour',
                    'option1'       : '1 heure',
                    'option2'       : '{0} heures',
                    'option3'       : 'plus de 8 heures',
                },
                7 : {
                    'title'         : 'Pendant combien d’heures environ avez-vous besoin du service d’hôtesses chaque jour',
                    'option1'       : '1 heure',
                    'option2'       : '{0} heures',
                    'option3'       : 'plus de 8 heures',
                },
                8 : {
                    'title'         : 'Quelles missions devront être accomplies par les hôtesses?',
                    'body'          : 'Par exemple : j’ai besoin d’hôtesses de marque qui restent au niveau du guichet du stand et qui, éventuellement, distribuent des prospectus pour le salon, ainsi que d’une hôtesse bilingue qui nous aide à gérer les ventes...',
                },
                9 : {
                    'title'         : 'Langues requises',
                    'body'          : 'Choisissez et/ou indiquez les langues souhaitées',
                    'label1'        : 'Espagnol',
                    'label2'        : 'Italien',
                    'label3'        : 'Français',
                    'label4'        : 'Anglais',
                    'label5'        : 'Allemand',
                    'label6'        : 'Portugais',
                    'label7'        : 'Autres',
                },

                'errors' : {
                    'city'              : 'Choisissez une ville',
                    'event'             : 'Choisissez un événement',
                    'userName'          : 'Vous devez ajouter le nom d’utilisateur',
                    'userEmail'         : 'Vous devez ajouter l’adresse électronique',
                    'userPhone'         : 'Vous devez ajouter le numéro de téléphone',
                    'invalidEmail'      : 'Vous devez ajouter une adresse électronique valide',
                    'profile'           : 'Sélectionnez un profil',
                    'countHostesses'    : 'De combien d´hôtesses aurez-vous besoin?',
                    'countDays'         : 'Pendant combien de jours?',
                    'deadline'          : 'Indiquez la date de l’événement',
                    'days'              : 'Complétez le programme quotidien',
                    'hoursAvg'          : 'Complétez les heures de la journée',
                    'tasks'             : 'Quelle sera la mission des hôtesses?',
                    'langs'             : 'Quelles langues doivent parler les hôtesses?',
                    'otherLang'        : 'Indiquez d’autres langues',
                }
            }

        },

        catering : {

            thanks : {
                title         : 'Merci!'
            },

            guests: 'Invités',

            1 : {
                title         : 'Demande de traiteur',
                subtitle      : 'Dans quelle ville et pour quel événement avez-vous besoin du service?',
                label1        : 'Dans quelle ville avez-vous besoin du service?',
                label2        : 'Indiquez le nom de l´événement',
                placeholder   : 'Écrivez ou sélectionnez un élément',
            },
            2 : {
                title         : 'Demande de traiteur',
                subtitle      : 'Vos coordonnées',
                placeholder1  : 'Votre nom',
                placeholder2  : 'Votre adresse électronique',
                placeholder3  : 'Votre numéro de téléphone',
            },
            3 : {
                title:      'Indiquez pendant combien de jours vous avez besoin du service de traiteur',
                label_days: 'Nombre de jours',
                label_date: 'Malheureusement, nous n’avons pas trouvé l’événement dans notre base de données, veuillez nous indiquer la date à laquelle il commence',

            },
            4 : {
                title         : 'Combien d’invités attendez-vous?',
            },

            5 : {
                title: 'Combien d’invités attendez-vous par jour?',
            },
            6 : {
                title         : 'Environ combien d’invités attendez-vous par jour?',
            },
            7 : {
                title         : 'Quel type de service cherchez-vous?',
                title2        : 'À quelle heure souhaitez-vous obtenir le service de traiteur?',
                label1        : 'Buffet pendant l’événement',
                label2        : 'Pause café',
                label3        : 'Plats principaux',
                label4        : 'Toute la journée',
                label5        : 'Petit-déjeuner',
                label6        : 'Déjeuner',
                label7        : 'Dîner',
            },
            8 : {
                title         : 'Quels services doivent être inclus dans le budget?',
                label1        : 'Serveurs',
                label2        : 'Boissons fraîches et cafés',
                label3        : 'Boissons alcoolisées',
                label4        : 'Déjeuner',
                label5        : 'Mobilier',
                label6        : 'Couverts, verres...',
            },
            9 : {
                title         : 'Budget',
                label1        : 'Budget par invité',
                label2        : 'Budget global de l’événement',
                text1         : 'Veuillez nous indiquer le budget maximum global dont vous disposez afin que nous vous présentions la meilleure option de traiteur dans cette fourchette de prix',
                text2         : 'Veuillez nous indiquer le budget maximum par invité afin que nous vous présentions la meilleure option de traiteur dans cette fourchette de prix',
            },
            10 : {
                title         : 'Souhaitez-vous ajouter quelque chose?',
                subtitle      : 'Si vous souhaitez des aliments spéciaux, mentionner des intolérances, commander un type de menu...'
            },

            labels : {

                service   : {
                    buffet        : 'Buffet',
                    coffeeBreak   : 'Pause',
                    mainDishes    : 'Plats principaux',
                },
                period    : {
                    allday        : 'Pendant tout l’événement',
                    breakfast     : 'Petit-déjeuner',
                    lunch         : 'Déjeuner',
                    dinner        : 'Dîner',
                },
                budgetType : {
                    byGuest : 'Budget par invité',
                    global  : 'Budget globa'
                }
            },

            errors : {
                city:         'Choisissez une ville',
                event:        'Choisissez un événement',
                userName:     'Vous devez ajouter le nom d’utilisateur',
                userEmail:    'Vous devez ajouter l’adresse électronique',
                userPhone:    'Vous devez ajouter le numéro de téléphone',
                invalidEmail: 'Vous devez ajouter une adresse électronique valide',
                days:         'Vous devez choisir le nombre de jours nécessaires',
                deadline:     'Indiquez la date de l’événement',
                guests:       'Vous devez ajouter le nombre d’invités',
                daysResume:   'Vous devez ajouter le nombre d’invités par jour',
                guestsAvg:    'Vous devez ajouter le nombre d’invités',
                period:       'Sélectionnez un horaire',
                service:      'Sélectionnez un service',
                budgetType:   'Sélectionnez une option pour le budget',
                budget:       'Introduisez le budget maximum',
                budgetFormat: 'Le budget maximum doit être un nombre entier'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand        : 'My brand:',
            page_navbar_data            : 'Data',
            page_navbar_presentation    : 'Presentation',
            page_navbar_geo             : 'Where you work',
            page_navbar_stands          : 'My stands',
            page_navbar_office          : 'office',
            page_navbar_scopes          : 'Scope',

            page_related_is_other       : 'Create new company',
            page_related_is_this        : 'This is my company',
            page_related_created_by     : 'Profile <b>created by {0}</b> on {1}',
            page_related_not_suggested  : "My company doesn't match with the suggestions, I would like to continue with the process:",

            page_resolution_label_1     : 'Do not do <b>anything</b>, we will solve it',
            page_resolution_label_2     : '{0} will continue managing the brand but <b>I want permissions to update content, receive leads</b>, ...',
            page_resolution_label_3     : '{0} is not longer responsible for managing this content, <b>from now on I will be the responsible</b> for this',

            labels : {
                name                    : 'Company name',
                city                    : 'City',
                sector                  : 'Sector',
                address                 : 'Address',
                web                     : 'Website',
            },

            alerts : {

                group_suppliers_text_1  : '<b>Is this your company?</b>',
                group_suppliers_text_2  : 'Someone from your company has a profile on neventum - we know by the corporate mail -',
                group_suppliers_text_3  : 'We thought it was a good idea to tell you, then if is the same company you can simplify your task ;)',
                group_suppliers_text_4  : "If you were going to create this company tell us and request to, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                other_suppliers_text_1  : '<b>Is this your company?</b>',
                other_suppliers_text_2  : 'Based on the information you filled we found similar brands on neventum.',
                other_suppliers_text_3  : "We show the following brands to avoid duplicating a one that was already created by your colleague.",
                other_suppliers_text_4  : "If you were going to create that company tell us and ask, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                resolution_text_1        : '<b>Great!</b>',
                resolution_text_2        : 'Just we need to know who will manage the brand from now on: you, your colleague, both...',
                resolution_text_3        : 'Select an option',

            },

            page_thank_send_email       : 'We sent an email to {0} to allow the permissions you need',
            page_thank_we_wait          : 'Looking forward to hearing from you!',
            page_thank_will_help        : 'I will help you to change {0} owner, I will contact you soon to begin the process.',

        }
    },
    event : {

        page_related_from_to        : 'from {0} to {1}',
        page_related_is_this        : 'Claim Event',
        page_related_not_suggested  : "My event doesn't match with the suggestions, I would like to continue with the process:",
        page_related_is_other       : 'None of these',

        page_thank_label_1          : 'Hello {0},',
        page_thank_label_2          : 'Our content team is evaluating your request to include the event on your profile.',
        page_thank_label_3          : 'In less than 24 hours ( not including holidays ) we will solve it ;)',
        page_thank_label_4          : 'We will keep you informed and invite you to include more events',
        page_thank_label_5          : 'Greetings',
        page_thank_label_6          : 'neventum Editorial Staff',

        labels : {
            'sector'                : 'Event sector',
            'periodicity'           : 'Event periodicity',
            'scope'                 : 'Event scope',
            'name'                  : 'Event name'
        },

        periodicity : {
            mensual                 : 'Monthly',
            trimestral              : 'Quarterly',
            semestral               : 'Biannual',
            anual                   : 'Anual',
            bienal                  : 'Biennial',
            trienal                 : 'Triennial',
            cuatrienal              : 'Four year',
        },

        scopes : {
            local                   : 'Local',
            national                : 'National',
            international           : 'International',
        },

        alerts : {

            related_events_text_1 : '<b>Is this your event?</b>',
            related_events_text_2 : 'Based on the information you filled about your event, we found similar events on neventum.',
            related_events_text_3 : 'To avoid duplicating an event that is already included in the calendar we show you below.',
            related_events_text_4 : 'If you were going to create that event tell us and ask, if you wish, permission to edit it',

        },
    },

    reviews : {

        thanks : "Merci de nous donner votre avis",

        labels : {

            rate                : "Votre note globale",
            opinion             : "TVotre avis",

            city                : "EVille dans laquelle le stand a été construit",
            city_stands         : "EVille dans laquelle le stand a été construit",
            city_catering       : "Où était l'évènement?",
            city_hostesses      : "Dans quelle ville avez-vous demandé les hôtesses?",

            worked_at           : "Date à laquelle le stand a été construit",
            worked_at_stands    : "Date à laquelle le stand a été construit",
            worked_at_catering  : "Quand était - ce l'événement?",
            worked_at_hostesses : "Quand était - ce l'événement?",

            name      : "Votre nom",
            email     : "Votre adresse mail",
            anonymous : "Je veux que mon avis soit anonyme, mon nom n'apparaîtra pas et ne sera pas communiqué au fournisseur sur lequel j'exprime une opinion.",
            accept    : "Je certifie que cet avis est basé sur ma propre expérience et qu'il s'agit d'un avis authentique au sujet de ce fournisseur, que je n'ai aucune relation personnelle ou d'affaires avec ce fournisseur et que je n'ai reçu aucune forme d'incitation ou de paiement pour rédiger cet avis. Je comprends que neventum a une politique de tolérance zéro concernant les faux avis.",
            submit    : "Envia tu opinión",
        },

        help : {
            name  : "Votre nom ne sera pas rendu public si vous nous l'indiquez",
            email : "Cette information ne sera JAMAIS publique",
        },
    },

    rate : {
        label           : "Cliquez pour évaluer votre expérience",
        label_bad       : "Mauvaise",
        label_poor      : "Décevante",
        label_fair      : "Moyenne",
        label_good      : "Bonne",
        label_excellent : "Excellente",
    },

    cookie : {
        text            : "Les cookies récupèrent des informations dans votre navigateur Web afin de vous offrir une meilleure expérience en ligne. Sur neventum, nous utilisons des cookies, si vous poursuivez sur le site, nous considérons que vous acceptez leur usage.",
        label_accept    : "Accepter",
        label_info      : "Pour plus d'information",
    },

    session : {
        login :     'Commencer une session',
        register :  "S'inscrire",
    }
};








// WEBPACK FOOTER //
// ./resources/js/i18n/fr.js